<template>
  <div>
    <van-nav-bar title="移动考勤申请" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="移动考勤申请说明" name="1" icon="calendar-o">
        <div style="color: red" v-html="this.tips"></div>
      </van-collapse-item>
    </van-collapse>
    <van-form class="login-form-top">
      <van-field
        v-model="realName"
        name="realName"
        label="姓名"
        readonly
      />
      <van-field
        readonly
        clickable
        name="lbsReason"
        :value="lbsReasonName"
        label="外勤事由"
        placeholder="点击选择外勤事由"
        @click="lbsReasonShow = true"
        :rules="[{ required: true, message: '请选择外勤事由' }]"
      />
      <van-action-sheet v-model="lbsReasonShow" :actions="lbsReasonList" @select="lbsReasonClick"/>
      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="具体事项"
        type="textarea"
        maxlength="50"
        placeholder="请填写具体事项"
        show-word-limit
      />
      <van-field name="applyFile" label="照片">
        <template slot="input">
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                        :before-delete="beforeApplyFileDelete"
                        capture="camera"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
          </van-uploader>
        </template>
      </van-field>
      <van-field
        v-model="addr"
        name="addr"
        label="当前位置"
        readonly
        right-icon="location-o"
        @click="showPoiList"
      />
      <!--      <van-field-->
      <!--        v-model="searchAddr"-->
      <!--        name="addrSearch"-->
      <!--        label="地址搜索"-->
      <!--        placeholder="请输入地址关键字"-->
      <!--        :rules="[{ required: true, message: '请输入地址关键字' }]">-->
      <!--        <template slot="button">-->
      <!--          <van-button size="small" type="primary" @click="search">搜索</van-button>-->
      <!--        </template>-->
      <!--      </van-field>-->
      <baidu-map class="bm-view" :zoom="15" @ready="initMap">
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                        @locationSuccess="locationSuccess"
                        :showAddressBar="true"
                        :autoLocation="true">

        </bm-geolocation>
        <!--        <bm-local-search-->
        <!--          :location="locationPoint"-->
        <!--          :keyword="keyword"-->
        <!--          :nearby="nearby"-->
        <!--          :auto-viewport="true"-->
        <!--          :panel="false"-->
        <!--          :forceLocal="true"-->
        <!--          @searchcomplete="searchcomplete"-->
        <!--          :selectFirstResult="false"-->
        <!--          :pageCapacity="10"></bm-local-search>-->
        <!--        <bm-circle :center="nearby.center"-->
        <!--                   :radius="nearby.radius"-->
        <!--                   :fillOpacity="0.5"-->
        <!--                   :strokeWeight="1"-->
        <!--                   :massClear="false" @lineupdate="updateCirclePath"></bm-circle>-->
      </baidu-map>
    </van-form>
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="taskSubmit">签到</van-button>
    </div>

    <van-dialog v-model="roleShow" title="我的角色" show-cancel-button @confirm="roleCommit" confirmButtonText="签到">
      <van-radio-group v-model="roleRadio">
        <van-cell-group>
          <van-cell :title="item.roleName" clickable v-for="item in roleList" :key="item.roleAlias"
                    clickable @click="roleRadio = item.roleAlias">
            <template slot="right-icon">
              <van-radio :name="item.roleAlias"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod" :getFlowParamsMethod="getFlowParamsMethod"/>

    <van-dialog v-model="addrShow" title="附近地址" show-cancel-button @confirm="addrCommit" confirmButtonText="确认">
      <van-radio-group v-model="addrRadio">
        <van-cell-group>
          <van-cell :title="item.title" clickable v-for="item in addrList" :key="item.title"
                    clickable @click="addrRadio = item.title">
            <template slot="right-icon">
              <van-radio :name="item.title"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import Vue from "vue";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "lbsAttendanceForm",
  data() {
    return {
      modelKey: "lbsAttendance",
      activeNames: ['1'],
      taskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      lbsReason: '',
      lbsReasonName: '',
      lbsReasonList: [],
      lbsReasonShow: false,
      realName: '',
      deptName: '',
      userInfo: {},
      lbsAttendanceId: 0,
      choseRoleId: '',
      nextProcess: false,
      addr: '',
      reason: '',
      showFiles: [],
      allFiles: {
        applyFiles: [],
        removedFiles: [],
      },
      applyFileIds: [],
      workYear: 0,
      roleShow: false,
      roleRadio: 0,
      roleList: [],
      pageType: 0,
      processShow: false,
      tips: '',
      keyword: '',
      searchAddr: '',
      locationPoint: {},
      cardTime: '',
      map: {},
      nearby: {
        center: {
          lng: 0,
          lat: 0
        },
        radius: 500
      },
      addrShow: false,
      addrRadio: 0,
      addrList: [],
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.lbsAttendanceId = this.$route.query.lbsAttendanceId;
    this.pageType = this.$route.query.pageType;
    this.initUserInfo();
  },
  methods: {
    initMap({BMap, map}) {
      const that = this;
      const geolocation = new BMap.Geolocation({
        maximumAge: 10  // 清除缓存
      });
      this.map = map;
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          const mk = new BMap.Marker(r.point);
          that.locationPoint = r.point;
          that.nearby.center = r.point;
          map.addOverlay(mk);
          map.panTo(r.point);
          const gc = new BMap.Geocoder()
          gc.getLocation(r.point, function (rs) {
            let addComp = rs.addressComponents;
            that.addr = addComp.city + addComp.district + addComp.street + addComp.streetNumber;
            that.addrList = rs.surroundingPois;
            //that.addr = rs.address
          });
        } else {
          alert("failed" + this.getStatus());
          that.addr = "未获取到定位";
        }
      });
    },
    locationSuccess(e) {
      const that = this;
      const gc = new BMap.Geocoder();
      gc.getLocation(e.point, function (rs) {
        let addComp = rs.addressComponents;
        that.addr = addComp.city + addComp.district + addComp.street + addComp.streetNumber;
        that.addrList = rs.surroundingPois;
        //that.addr = rs.address
      })
      this.map.clearOverlays();
      const mk = new BMap.Marker(e.point);
      this.locationPoint = e.point;
      this.nearby.center = e.point;
      this.map.addOverlay(mk);
      this.map.panTo(e.point);
      // if (this.addrList.length == 0) {
      //   Toast('当前位置未查询到附近地址信息！');
      // } else {
      //   this.addrShow = true;
      // }
    },
    searchcomplete(val) {
      if (val != undefined) {
        if (val.Kr.length == 0) {
          Toast('未查询到相关地址！');
        } else {
          this.addrList = val.Kr;
          this.addrShow = true;
        }
      }
    },
    updateCirclePath(e) {

    },
    search() {
      this.keyword = this.searchAddr;
    },
    showPoiList() {
      if (this.addrList.length == 0) {
        Toast('当前位置未查询到附近地址信息！');
      } else {
        this.addrShow = true;
      }
    },
    addrCommit() {
      this.addrShow = false;
      this.addr = this.addrRadio;
      this.addrList.forEach(v => {
        if (v.title == this.addr) {
          this.locationPoint = v.point;
        }
      });
    },
    initUserInfo() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.realName = user.realName;
          this.deptName = user.deptName;
          this.userInfo = user;
          this.workYear = user.workYear;
          this.dictionaryInit();
        }
      );
    },
    dictionaryInit() {
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'lbs_reason'
      }).then(res => {
        const data = res.data;
        this.lbsReasonList = data;
        this.lbsReasonList.forEach(v => {
          v.name = v.dictValue;
        });
        this.getInitData();
      });
      this.$fetch("/attence-api/blade-system/param/getSystemParam", {
        key: 'LAB_ATTENDANCE_PROMPT'
      }).then(res => {
        const data = res.data;
        if (data != null) {
          this.tips = data;
        }
      });
    },
    getInitData() {
      //如果当前流程已数据
      this.$fetch("/attence-api/blade-manager/otherAttenceRecord/flowDetailByFlowAppNo", {
        flowAppNo: this.appNo,
      }).then(res => {
        const data = res.data;
        if (data.id != undefined) {
          this.lbsAttendanceId = data.id;
          this.cardTime = data.cardTime;
          this.realName = data.name;
          this.lbsReason = data.reasonType;
          this.lbsReasonName = data.reasonTypeToString;
          this.reason = data.reason;
          this.allFiles = data.allFiles;
          this.showFiles = data.allFiles.applyFiles;
          this.showFiles.forEach(v => {
            this.applyFileIds.push(v.id);
            v.url = replaceUrl(v.viewUrl);
          });
        }
      });
    },
    lbsReasonClick(item) {
      this.lbsReasonShow = false;
      this.lbsReason = item.dictKey;
      this.lbsReasonName = item.name;
    },
    onClickLeft: function () {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/lbsAttendance/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'applyFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          this.allFiles.applyFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    taskSubmit() {
      if (this.lbsReason == '') {
        Toast('请选择外勤事由');
        return;
      }

      if (this.reason == '') {
        Toast('请填写具体事项');
        return;
      }

      // if (this.applyFileIds.length == 0) {
      //   Toast('请上传照片');
      //   return;
      // }

      this.$fetch("/attence-api/blade-user/getUserFlowRoleList", {}).then(res => {
        const data = res.data;
        this.roleList = [];
        data.forEach((v) => {
          if (v.roleFlow != undefined && v.roleFlow != "") {
            const flowLit = v.roleFlow.split("|");
            flowLit.forEach((flow) => {
              if (this.modelKey == flow) {
                this.roleList.push(v);
              }
            });
          }
        });
        if (this.roleList.length > 0) {
          if (this.roleList.length > 1) {//流程发起角色大于1个选择角色发起流程
            this.roleRadio = this.roleList[0].roleAlias;
            this.choseRoleId = this.roleList[0].roleAlias;
            this.roleShow = true;
          } else {
            this.choseRoleId = this.roleList[0].roleAlias;
            this.showProcessInfo();
          }
        } else {
          Toast('未配置流程发起角色，请联系统系管理员！');
        }
      });
    },
    roleCommit() {
      this.choseRoleId = this.roleRadio;
      this.showProcessInfo();
    },
    choseRoleSubmit() {
      const params = {
        id: this.lbsAttendanceId,
        reasonType: this.lbsReason,
        reason: this.reason,
        addr: this.addr,
        baiduLng: this.locationPoint.lng,
        baiduLat: this.locationPoint.lat,
        allFiles: this.allFiles,
        appNo: this.appNo,
        taskId: this.taskId,
        cardTime: this.cardTime,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      //流程参数
      params.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          auditStatus: '',
        }
      };
      params.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-manager/otherAttenceRecord/start-process", params).then(resp => {
        const data = resp.data;
        Toast('流程提交成功');
        this.roleShow = false;
        this.processShow = true;
        this.jumpPage();
      });
    },
    jumpPage() {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/lbsAttendance/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    showProcessInfo() {
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
      this.roleShow = false;
    },
    submitFlowMethod() {
      this.choseRoleSubmit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      const params = {
        businessId: "",
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          auditStatus: " ",
          selectedRole: this.choseRoleId,
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.bm-view {
  width: 100%;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/lbsAttendance/form.vue